import ServiceManagement from "src/containers/aiPlatform/service/ServiceManagement";
import UserManagement from "src/containers/aiPlatform/user/UserManagement";
import UserServiceManagement from "src/containers/aiPlatform/userService/UserServiceManagement";
import CommunityContext from "src/containers/community/CommunityContext";
import EnterpriseContext from "src/containers/enterprise/EnterpriseContext";
import Home from "src/containers/home/Home";
import PublishedPackage from "src/containers/installation/PublishedPackage";
import LicenseForm from "src/containers/license/LicenseForm";
import LicenseList from "src/containers/license/LicenseList";
import UserManage from "src/containers/userManage/UserManage";

export interface RouterItem {
  type: string;
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any;
  defauleParams?: Record<string, string>;
}

export const routers: Record<string, RouterItem> = {
  home: {
    type: "home",
    path: "/",
    component: Home,
  },
  userManage: {
    type: "userManage",
    path: "/userManage",
    component: UserManage,
  },
  enterpriseTenant: {
    type: "companyManage",
    path: "/companyManage/enterpriseTenant",
    component: EnterpriseContext,
  },
  communityTenant: {
    type: "companyManage",
    path: "/companyManage/communityTenant",
    component: CommunityContext,
  },
  licenseManage: {
    type: "licenseManage",
    path: "/license/licenseManage",
    component: LicenseList,
  },
  licenseSign: {
    type: "license",
    path: "/license",
    component: LicenseForm,
    defauleParams: {
      licenseType: "",
    },
  },
  installation: {
    type: "installation",
    path: "/installation",
    component: PublishedPackage,
  },
  aiUser: {
    type: "ai",
    path: "/ai/userManage",
    component: UserManagement,
  },
  aiUserService: {
    type: "ai",
    path: "/ai/userServiceManage",
    component: UserServiceManagement,
  },
  aiService: {
    type: "ai",
    path: "/ai/serviceManage",
    component: ServiceManagement,
  },
};
